const TIME_FORMAT_REGEX = /^([0-9]{1,2}):([0-5][0-9])$/;

export const formatMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

// "00:00" parses to 0, not null — VAL-SOL-01 blocks on the RESOLVED amount,
// not on an empty field.
export const parseHHMMToMinutes = (value: string): number | null => {
  const match = TIME_FORMAT_REGEX.exec(value.trim());
  if (!match) {
    return null;
  }
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23) {
    return null;
  }
  return hours * 60 + minutes;
};

// RN-SOL-29 — a jornada stays open (today or later); the banner only informs,
// it never blocks the save.
export const isJornadaOpen = (date: Date): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const compareDate = new Date(date);
  compareDate.setHours(0, 0, 0, 0);
  return compareDate.getTime() >= today.getTime();
};

const NO_SHIFT_NAME = '—';

// The row and the detail drawer must agree on what counts as "no shift".
// `shift_name` can arrive as an empty string, which `?? ` would let through
// and show as a blank cell in one place and a dash in the other.
export const hasShiftName = (
  shiftName: string | null | undefined,
): shiftName is string => Boolean(shiftName);

export const formatShiftName = (
  shiftName: string | null | undefined,
): string => (hasShiftName(shiftName) ? shiftName : NO_SHIFT_NAME);
